import { render } from "./Specials.vue?vue&type=template&id=8abbb598&scoped=true"
import script from "./Specials.vue?vue&type=script&lang=js"
export * from "./Specials.vue?vue&type=script&lang=js"

import "./Specials.vue?vue&type=style&index=0&id=8abbb598&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8abbb598"]])

export default __exports__